import { NavigationPage } from '@/app/components'
import LinkDiagram from '@/app/features/logos/LinkDiagram'
import OptiwattIconLogo from '@/app/img/logo-icon-colored-filled.webp'
import TeslaLogo from '@/authenticated/images/tesla.webp'
import { match } from 'ts-pattern'
import ConnectionApiFailureView from './ConnectionApiFailureView'
import InitialConnectionView from './InitialConnectionView'
import KeyNotAttachedView from './KeyNotAttachedView'
import KeyConfirmationStatusModal from './status'
import { useViewModel } from './useViewModel'

export default function KeyConfirmationPage() {
  const {
    onConfirmClick,
    onClose,
    status,
    modalDisplayStatus,
    vehicles,
    retryKeyConnection,
    restartKeyConnectionFlow,
    isLoading,
    onFailForModal,
    onPageExit,
  } = useViewModel()

  return (
    <NavigationPage
      id="onboarding-key-confirmation-nav-page"
      progressBar={{
        completedSteps: 2,
        totalSteps: 2,
      }}
      navigationOptions={['back', 'close']}
      onCloseClick={onPageExit}
    >
      <NavigationPage.SingleCardContent>
        <div className="mt-4">
          <LinkDiagram logos={[OptiwattIconLogo, TeslaLogo]} />
        </div>
        {match(status)
          .with('initial', () => (
            <InitialConnectionView
              onConfirmClick={onConfirmClick}
              isLoading={isLoading}
            />
          ))
          .with('loading', () => (
            <InitialConnectionView
              onConfirmClick={onConfirmClick}
              isLoading={true}
            />
          ))
          .with('api_failure', () => (
            <ConnectionApiFailureView
              onConfirmClick={onConfirmClick}
              isLoading={isLoading}
            />
          ))
          .with('key_not_attached', () => (
            <KeyNotAttachedView
              onConfirmClick={restartKeyConnectionFlow}
              isLoading={isLoading}
            />
          ))
          .with('success', () => (
            <InitialConnectionView
              onConfirmClick={onConfirmClick}
              isLoading={true}
            />
          ))
          .exhaustive()}

        <KeyConfirmationStatusModal
          id="key-confirmation-status-modal"
          open={modalDisplayStatus !== null && modalDisplayStatus !== 'failed'}
          mode={modalDisplayStatus ?? 'connecting'}
          onClose={onClose}
          onRetry={retryKeyConnection}
          vehicles={vehicles}
          onFailure={onFailForModal}
        />
      </NavigationPage.SingleCardContent>
    </NavigationPage>
  )
}
